'use es6';

const EMAIL_UNSUBSCRIBE_URL = new RegExp('^/email-unsubscribe/email/?$');
export const isEmailUnsubscribeUrl = url => EMAIL_UNSUBSCRIBE_URL.test(url);
export const isLegacyLink = ({
  v,
  d,
  email,
  product
} = {}) => v === '5' ? true : Boolean(email && d && product);
export const isPreferencesGroupLink = ({
  d,
  v: version
} = {}) => version === '4' && !!d;
export const isTestPreferencesGroupLink = ({
  isTest,
  groupId
} = {}) => {
  return isTest === 'true' && groupId;
};